import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { initSupportChat } from "@ledgerbox/support-chat"

import { readDemoRoute } from "./demo/route"
import { PortalApp } from "./portal-app"
import "./styles.css"

const demo = readDemoRoute()

/* The demo is the product with the data swapped, not a marketing page, so it
   gets no support widget: a visitor messaging support from a sample month has
   nothing anyone can help with. */
if (!demo) initSupportChat(import.meta.env.PROD ? "prod" : "local")

const root = document.getElementById("root")
if (!root) throw new Error("Portal root element is missing.")

/* The fixture and the ten personas are a few pages of sample text. A client
   opening their own portal should never download a word of it, so the demo is
   its own chunk, asked for only on the demo's own path. */
if (demo) {
  void import("./demo/demo-app").then(({ DemoApp }) => {
    createRoot(root).render(
      <StrictMode>
        <DemoApp route={demo} />
      </StrictMode>
    )
  })
} else {
  createRoot(root).render(
    <StrictMode>
      <PortalApp />
    </StrictMode>
  )
}
